import { render, staticRenderFns } from "./PersonGroupPieIcon.vue?vue&type=template&id=7efd8658&"
import script from "./PersonGroupPieIcon.vue?vue&type=script&lang=ts&"
export * from "./PersonGroupPieIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports